
import Vue from "vue";
import Top from "@/components/templates/Top.vue";
import i18n from '@/plugins/i18n';
import CSV from '@/components/templates/CSV.vue';
import CopyButton from '@/components/templates/CopyButton.vue';
export default Vue.extend({
  name: "ClickToCallTable",
  components: {
    CopyButton,
    CSV,
    Top,
  },
  data() {
    return {
      search: '',
      computedList: [
      {
        id: 1,
        caller: "123456789",
        destination: "987654321",
        cdrID: "CDR12345",
        date: "2024-12-23 12:00:00",
      },
      {
        id: 2,
        caller: "223344556",
        destination: "112233445",
        cdrID: "CDR67890",
        date: "2024-12-23 13:00:00",
      },
      {
        id: 3,
        caller: "334455667",
        destination: "998877665",
        cdrID: "CDR13579",
        date: "2024-12-23 14:00:00",
      },
    ],
    };
  },
  methods:{
    clickToCallNew(){
      this.navigateTo('clickToCall');
    },
    headers() {
      return [
        {
          text: 'ID',
          value: 'id',
          width: '70px',
        },
        {
          text: i18n.t('misc.from'),
          value: 'caller',
        },
        {
          text: i18n.t('misc.to'),
          value: 'destination',
        },
        {
          text: "cdrID",
          value: 'cdrID',
        },
        {
          text: i18n.t('misc.date'),
          value: 'date',
        }
      ];  
    },
    navigateTo(navTo: string) {
      if (navTo !== this.$route.name) {
        this.$router.replace({
          name: navTo,
          params: {
            corp: localStorage.getItem('corp') || '',
            lang: this.$i18n.locale,
          },
        });
      }
    },
  }
});
